














































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import CKEditor from "@/components/ckeditor.vue";

@Component({
  components: { ckeditor: CKEditor },
})
export default class extends Mixins(MyForm) {
  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("productfeatures/add", {
              ...fieldValues,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);

              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }
}
